import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DashboardCalendar from '../../../components/dashboard/calendar/DashboardCalendar';
import WeekAgenda from '../../../components/dashboard/calendar/WeekAgenda';
import { listSchedules, unloadUserSchedules } from '../../../modules/userModule/schedules';
import TechEditStepperModalContainer from './tech/TechEditStepperModalContainer';


//https://c.io/docs/event-object
//type:기술지원, type:휴가
const DashboardCalendarContainer = ({ toggleCalFull, full }) => {
  const dispatch = useDispatch();

  const { schedules, error, loading } = useSelector(
    ({ userModule, loading }) => ({
      schedules: userModule.schedules.schedules,
      error: userModule.schedules.error,
      loading: loading['user/LIST_USER_SCHEDULES'],
    }),
  );

  const [type, setType] = useState(null);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);


  const handleClose = () => {
    setOpen(false);
    setSelectedEvent(null);
  };


  useEffect(() => {
    dispatch(listSchedules());
  }, [])

  useEffect(() => {
    if (schedules) {
      setEvents([...schedules])
    }

  }, [schedules])



  const handelEventClick = (e) => {
    //console.log(e.event.extendedProps, "event");
    setSelectedEvent(e.event);
    setType(e.event.extendedProps.type)
    handleOpen();
  }

  if (loading || !schedules) {
    return null;
  }

  return (
    <>
      {full ? (
        <DashboardCalendar events={events} handelEventClick={handelEventClick} toggleCalFull={toggleCalFull} full={full} />
      ) : (
        // 메인화면 비주얼 리뉴얼(2026-10-23) - 카드 안에서는 큰 월간 달력 대신 "이번 주 일정"
        // 아젠다만 보여준다. 전체 보기(toggleCalFull)로 넘어가면 위 FullCalendar 뷰가 그대로 나온다.
        <WeekAgenda events={events} onEventClick={handelEventClick} />
      )}
      {open && type === 'tech' && <TechEditStepperModalContainer open={open} handleClose={handleClose} reqId={selectedEvent.extendedProps.taskUuid} />}
    </>
  );
};

export default DashboardCalendarContainer;
